module.exports = __webpack_public_path__ + "img/xak_text.f3f2127f.png";